import { IPublicClientApplication } from '@azure/msal-browser';
import { NominationScrubbingStatus } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  getAwardNominationScrubbingStatus,
  getCountryAwardNominationScrubbingStatus,
  overrideAwardNominationScrubbing,
  overrideCountryAwardNominationScrubbing,
  updateAwardNominationScrubbingStatus,
  updateCountryAwardNominationScrubbingStatus,
} from './index';

export const createScrubbingStatusApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardNominationScrubbingStatus: (instance: IPublicClientApplication, awardId: number, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardNominationScrubbingStatus(fetchContext, awardId, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardNominationScrubbingStatus', isInFlight);
    },
  ),
  getCountryAwardNominationScrubbingStatus: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardNominationScrubbingStatus(fetchContext, programId, countryId, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardNominationScrubbingStatus', isInFlight);
    },
  ),
  overrideAwardNominationScrubbing: (instance: IPublicClientApplication, awardId: number, nominationId: number, overrideJustification: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => overrideAwardNominationScrubbing(fetchContext, awardId, nominationId, overrideJustification, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('overrideAwardNominationScrubbing', isInFlight);
    },
  ),
  overrideCountryAwardNominationScrubbing: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number, overrideJustification: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => overrideCountryAwardNominationScrubbing(fetchContext, programId, countryId, nominationId, overrideJustification, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('overrideCountryAwardNominationScrubbing', isInFlight);
    },
  ),
  updateAwardNominationScrubbingStatus: (instance: IPublicClientApplication, awardId: number, nominationId: number, scrubbingStatus: NominationScrubbingStatus) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateAwardNominationScrubbingStatus(fetchContext, awardId, nominationId, scrubbingStatus, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateAwardNominationScrubbingStatus', isInFlight);
    },
  ),
  updateCountryAwardNominationScrubbingStatus: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number, scrubbingStatus: NominationScrubbingStatus) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateCountryAwardNominationScrubbingStatus(fetchContext, programId, countryId, nominationId, scrubbingStatus, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateCountryAwardNominationScrubbingStatus', isInFlight);
    },
  ),
});
